import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { ROUTES, MORE_ICON } from "../routesConfig";

export default function BottomNav() {
  const [open, setOpen] = useState(false);

  // Filtrer les routes principales et secondaires
  const main = ROUTES.filter(r => r.primaryMobile);
  const more = ROUTES.filter(r => !r.primaryMobile);

  return (
    <div className="md:hidden">
      {/* Popover "Plus" */}
      {open && (
        <div
          className="fixed inset-0 z-[10999]"
          onClick={() => setOpen(false)}
          aria-hidden
        >
          <div
            className="absolute bottom-16 right-2 w-56 rounded-xl border bg-white shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <ul className="p-2">
              {more.map((m) => (
                <li key={m.path}>
                  <NavLink
                    to={m.path}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      [
                        "flex items-center gap-3 rounded-lg px-3 py-2 text-sm",
                        isActive ? "bg-black text-white" : "text-gray-800 hover:bg-gray-100",
                      ].join(" ")
                    }
                  >
                    <m.icon className="h-4 w-4" />
                    <span>{m.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Barre fixe bas d'écran */}
      <div
        className="
          fixed bottom-0 inset-x-0
          z-[11000]
          h-16 border-t bg-white
          pb-[env(safe-area-inset-bottom)]
        "
        role="navigation"
        aria-label="Navigation principale"
      >
        <div className="grid h-full grid-cols-6">  {/* ← CHANGÉ ICI : grid-cols-6 en dur */}
          {main.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                [
                  "flex flex-col items-center justify-center text-xs",
                  isActive ? "text-black" : "text-gray-600",
                ].join(" ")
              }
            >
              <item.icon className="h-5 w-5" />
              <span className="mt-0.5">{item.label}</span>
            </NavLink>
          ))}

          {/* Plus (seulement s'il y a des items secondaires) */}
          {more.length > 0 && (
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex flex-col items-center justify-center text-xs text-gray-600"
              aria-haspopup="menu"
              aria-expanded={open}
            >
              <MORE_ICON className="h-5 w-5" />
              <span className="mt-0.5">Plus</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}